const INITIAL_STATE = {
  isAcceptTerms: null,
  message: ''
};

export default {
  setGuid: (state, payload) => (state.guid = payload),
  loginSuccess: (state, payload) => (state.user = payload),
  logoff: state => {
    sessionStorage.clear();
    localStorage.removeItem(state.config.VUE_APP_TOKEN_KEY);
    state.user = INITIAL_STATE;
  },
  userNotAcceptTerms: (state, payload) => (state.user = payload),
  setConfig: (state, payload) => (state.config = payload),
  setCaptcha: (state, payload) => (state.showCaptcha = payload)
};
